import type {ActivityChatMessage, ChatMessage} from '../types';

import {buildGroupedActivityMessage} from './buildActivityGroupMessage';

export const GROUP_ACTIVITIES_TIME_WINDOW = 5 * 60000;

export const isSameActivityType = (
    previousMessage: ActivityChatMessage,
    lastActivityMessages: ActivityChatMessage,
) => previousMessage.activityType === lastActivityMessages.activityType;

export const isActivityInTimeRange = (
    previousMessage: ActivityChatMessage,
    lastActivityMessages: ActivityChatMessage,
) =>
    previousMessage.at.getTime() + GROUP_ACTIVITIES_TIME_WINDOW >=
    lastActivityMessages.at.getTime();

export const shouldAppendActivityMessage = (
    lastMessage: ChatMessage,
    newMessage: ActivityChatMessage,
): lastMessage is ActivityChatMessage =>
    lastMessage.type === 'activity' &&
    isSameActivityType(lastMessage, newMessage) &&
    isActivityInTimeRange(lastMessage, newMessage);

export const getGroupActivityMessages = (
    messages: ChatMessage[],
    newMessage: ActivityChatMessage,
) => {
    const lastMessage = messages.at(-1);

    if (lastMessage && shouldAppendActivityMessage(lastMessage, newMessage)) {
        messages.splice(
            messages.length - 1,
            1,
            buildGroupedActivityMessage(lastMessage, newMessage),
        );
        return Array.from(messages);
    }

    return [...messages, newMessage];
};
